import { type PurchaseState } from '../../apiRtk/be4feMy2nApi';

export const GOLD_LICENSE_PACK = [
  'LICENCE_ENHANCED_SECURITY',
  'LICENCE_ENHANCED_AUDIO',
  'LICENCE_ENHANCED_VIDEO',
  'LICENCE_ENHANCED_INTEGRATION',
  'LICENCE_NFC',
];

export const GOLD_LICENSE = 'LICENCE_GOLD';

export const GP_WEBPAY = 'GP_WEBPAY';
export const INVOICE = 'INVOICE';
export const PADDLE = 'PADDLE';
export const CARD_PAYMENT_METHODS = new Set<string>([GP_WEBPAY, PADDLE]);
export const PADDLE_ENVIRONMENT: 'sandbox' | 'production' = process.env.PADDLE_ENVIRONMENT === 'production' ? 'production' : 'sandbox';
export const PAYMENT_STATUS_POLLING_INTERVAL_MS = 3000;
export const PAYMENT_STATUS_POLLING_TIMEOUT_MS = 90000;
export const PAYMENT_STATUS_POLLING_PAGE_SIZE = 10;

export const TERMINAL_PURCHASE_STATES: ReadonlySet<PurchaseState> = new Set<PurchaseState>([
  'PAID',
  'DELIVERED',
  'INVOICE_ISSUED',
  'BEFORE_COMPLETION',
  'COMPLETED',
  'FAILED',
  'CANCELLED',
]);

export const MOBILE_VIDEO_POOL_CREDIT = 'MOBILE_VIDEO_POOL_CREDIT';
export const PROMO = 'PROMO';

export const INTERCOM_LICENCES = {
  LICENCE_ACCESS_UNIT_LIFT_MODULE: 'LICENCE_ACCESS_UNIT_LIFT_MODULE',
  LICENCE_ENHANCED_AUDIO: 'LICENCE_ENHANCED_AUDIO',
  LICENCE_ENHANCED_INTEGRATION: 'LICENCE_ENHANCED_INTEGRATION',
  LICENCE_ENHANCED_SECURITY: 'LICENCE_ENHANCED_SECURITY',
  LICENCE_ENHANCED_VIDEO: 'LICENCE_ENHANCED_VIDEO',
  LICENCE_G729: 'LICENCE_G729',
  LICENCE_GOLD: 'LICENCE_GOLD',
  LICENCE_INFORMCAST: 'LICENCE_INFORMCAST',
  LICENCE_INTERCOM_LIFT_MODULE: 'LICENCE_INTERCOM_LIFT_MODULE',
  LICENCE_NFC: 'LICENCE_NFC',
  LICENCE_NFC_ACCESS_UNIT: 'LICENCE_NFC_ACCESS_UNIT',
};
